import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1abc863d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "book__status is-new"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text__date" }
const _hoisted_4 = { class: "book__thumb" }
const _hoisted_5 = { class: "book__thumb_img" }
const _hoisted_6 = {
  key: 0,
  class: "book__actionArea"
}
const _hoisted_7 = {
  key: 0,
  class: "actionButton__inner"
}
const _hoisted_8 = { class: "actionButton__icon" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "actionButton__text" }, "いれる", -1))
const _hoisted_10 = {
  key: 1,
  class: "actionButton__inner"
}
const _hoisted_11 = { class: "actionButton__icon" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "actionButton__text" }, "はずす", -1))
const _hoisted_13 = {
  key: 1,
  class: "book__name"
}
const _hoisted_14 = {
  key: 2,
  class: "book__grades"
}
const _hoisted_15 = {
  key: 3,
  class: "book__foot"
}
const _hoisted_16 = {
  key: 0,
  class: "book__stamp"
}
const _hoisted_17 = { class: "book__stamp_icon" }
const _hoisted_18 = { class: "book__stamp_count" }
const _hoisted_19 = {
  key: 1,
  class: "book__readSpeaker"
}

import { withDefaults, computed } from 'vue'

import { STAMPS } from '@/constants/stamps'

import AppImage from '@/components/AppImage/AppImage.vue'
import AppButton from '@/components/AppButton/AppButton.vue'

interface Props {
  contentsId: string
  contentsName?: string
  contentsStyle?: number
  gradeCodes?: number[]
  newBookFlg?: number | null
  stampId?: number | null
  stampIdCount?: number | null
  thumbnailPath: string
  bookShelfEntryFlg?: number
  hasAction?: boolean
  isLoading?: boolean
  isVisibleNewArea?: boolean
  pattern?: string | 'small' | 'default'
  releaseEndDate?: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Book',
  props: {
    contentsId: null,
    contentsName: { default: '' },
    contentsStyle: { default: undefined },
    gradeCodes: { default: undefined },
    newBookFlg: { default: 0 },
    stampId: { default: undefined },
    stampIdCount: { default: undefined },
    thumbnailPath: null,
    bookShelfEntryFlg: { default: undefined },
    hasAction: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: false },
    isVisibleNewArea: { type: Boolean, default: true },
    pattern: { default: 'default' },
    releaseEndDate: { default: null }
  },
  emits: ['add', 'remove', 'click:book'],
  setup(__props: any, { emit }) {

const props = __props as { contentsId: string, contentsName: string, contentsStyle: number, gradeCodes: number[], newBookFlg: number | null, stampId: number | null, stampIdCount: number | null, thumbnailPath: string, bookShelfEntryFlg: number, hasAction: boolean, isLoading: boolean, isVisibleNewArea: boolean, pattern: string | 'small' | 'default', releaseEndDate: string | null }

/**
 * Book.
 *
 * 書影.
 */





const gradeText = computed(() => {
  return (grade: number) => {
    switch (grade) {
      case 1:
        return '1・2ねんせい'
      case 2:
        return '3・4年生'
      case 3:
        return '5・6年生'
      case 4:
        return '中・高校生'
      case 5:
        return '小学生'
      case 6:
        return '低・中学年'
      case 7:
        return '中・高学年'
      case 8:
        return '高学年以上'
      default:
        return ''
    }
  }
})

// 本だな追加・削除
const onClickToggle = (
  contentsId: Props['contentsId'],
  bookShelfEntryFlg: Props['bookShelfEntryFlg']
) => {
  if (!bookShelfEntryFlg) {
    emit('add', contentsId)
  } else {
    emit('remove', contentsId)
  }
}

// スタンプ
const getStampDisplayName = (id: number) => {
  return STAMPS.filter((item) => id === item.id)[0].displayName
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["book", `book--${__props.pattern}`])
  }, [
    (__props.isVisibleNewArea)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            (__props.newBookFlg === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "NEW!"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.releaseEndDate), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: {
            name: 'BookDetail',
            params: { bookId: __props.contentsId },
          },
          class: "book__thumb_link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click:book', __props.contentsId)))
        }, {
          default: _withCtx(() => [
            _createVNode(AppImage, {
              src: __props.thumbnailPath ?? require('@/assets/image/img_book_none.svg'),
              noImageSrc: require('@/assets/image/img_book_404.svg'),
              width: "200",
              height: "200",
              alt: ""
            }, null, 8, ["src", "noImageSrc"])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (__props.hasAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: _normalizeClass(["actionButton animationLink", __props.isLoading ? 'is-loading' : '']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickToggle(__props.contentsId, __props.bookShelfEntryFlg)))
            }, [
              _createVNode(AppButton, {
                tag: "span",
                color: __props.bookShelfEntryFlg === 0 ? 'add' : 'remove',
                shadow: "s"
              }, {
                default: _withCtx(() => [
                  (__props.bookShelfEntryFlg === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, [
                          _createVNode(AppImage, {
                            src: require('@/assets/image/icon/icon_book_plus_s.svg'),
                            alt: "ほんだなにいれる",
                            width: "32",
                            height: "32"
                          }, null, 8, ["src"])
                        ]),
                        _hoisted_9
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, [
                          _createVNode(AppImage, {
                            src: require('@/assets/image/icon/icon_book_minus_s.svg'),
                            alt: "ほんだなからはずす",
                            width: "32",
                            height: "32"
                          }, null, 8, ["src"])
                        ]),
                        _hoisted_12
                      ]))
                ]),
                _: 1
              }, 8, ["color"])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.contentsName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(__props.contentsName), 1))
      : _createCommentVNode("", true),
    (__props.gradeCodes)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.gradeCodes, (grade, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "book__grade"
            }, [
              _createElementVNode("span", null, _toDisplayString(_unref(gradeText)(grade)), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (__props.stampId || __props.contentsStyle === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (__props.stampId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(AppImage, {
                    src: require(`@/assets/image/icon/stamp/${__props.stampId}.svg`),
                    alt: getStampDisplayName(__props.stampId),
                    width: "20",
                    height: "20"
                  }, null, 8, ["src", "alt"])
                ]),
                _createElementVNode("span", _hoisted_18, _toDisplayString(__props.stampIdCount), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.contentsStyle === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(AppImage, {
                  src: require('@/assets/image/icon/icon_speaker.svg'),
                  alt: "読み上げ",
                  lazyLoad: "",
                  width: "20",
                  height: "20"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})